"use client";

import { useEffect, useState } from "react";
import Chatbot from "../components/Chatbot";
import Footer from "../components/common/Footer";
import Quote from "../components/common/Quote";

function Home() {
  // State variables to manage accordion visibility
  const [domesticOpen, setDomesticOpen] = useState(false);
  const [industrialOpen, setIndustrialOpen] = useState(false);
  const [commercialOpen, setCommercialOpen] = useState(false);

  // Toggle function for accordions
  const toggleAccordion = (accordion) => {
    switch (accordion) {
      case "domestic":
        setDomesticOpen(!domesticOpen);
        break;
      case "industrial":
        setIndustrialOpen(!industrialOpen);
        break;
      case "commercial":
        setCommercialOpen(!commercialOpen);
        break;
      default:
        break;
    }
  };

  useEffect(() => {
    // Mobile menu toggle
    const menuBtn = document.getElementById("menu-btn");
    const mobileMenu = document.getElementById("mobile-menu");

    const handleMenuToggle = () => {
      if (mobileMenu) {
        mobileMenu.classList.toggle("hidden");
      }
    };

    if (menuBtn) {
      menuBtn.addEventListener("click", handleMenuToggle);
    }

    const initSlider = () => {
      if (typeof window !== "undefined" && window.jQuery) {
        // Initialize testimonial slider
        window.jQuery(".slider")
          .not(".partner-slider")
          .slick({
            infinite: true,
            slidesToShow: 3,
            slidesToScroll: 1,
            centerMode: true,
            focusOnSelect: true,
            autoplay: true,
            autoplaySpeed: 3000,
            responsive: [
              {
                breakpoint: 768,
                settings: {
                  slidesToShow: 1,
                  centerMode: false,
                },
              },
            ],
          });

        // Initialize partner slider
        window.jQuery(".partner-slider").slick({
          infinite: true,
          loop: true,
          slidesToShow: 6,
          slidesToScroll: 1,
          autoplay: true,
          autoplaySpeed: 2000,
          arrows: false,
          dots: false,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 6,
              },
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 5,
              },
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 3,
              },
            },
          ],
        });
      }
    };

    // Check if jQuery and slick are loaded
    const checkJQuery = () => {
      if (typeof window !== "undefined" && window.jQuery && window.jQuery.fn.slick) {
        initSlider();
      } else {
        // If not loaded yet, try again in 100ms
        setTimeout(checkJQuery, 100);
      }
    };

    checkJQuery();

    return () => {
      if (menuBtn) {
        menuBtn.removeEventListener("click", handleMenuToggle);
      }

      // Destroy slick sliders if they exist
      if (typeof window !== "undefined" && window.jQuery) {
        if (window.jQuery(".slider").slick) {
          window.jQuery(".slider").slick("unslick");
        }
        if (window.jQuery(".partner-slider").slick) {
          window.jQuery(".partner-slider").slick("unslick");
        }
      }
    };
  }, []);

  return (
    <div>
      <Chatbot />

      <div className="flex overflow-hidden flex-col pb-11 bg-white">
        <header className="flex relative z-10 flex-col items-center px-20 pb-20 w-full min-h-[800px] max-md:px-5 max-md:max-w-full">
          <video
            src="/assets/img/bg.mp4"
            alt="Hero background"
            className="object-cover absolute inset-0 size-full"
            autoPlay
            muted
            loop
          />
          <div className="absolute inset-0 bg-black/50"></div>

          <nav className="flex items-center justify-between w-full max-w-[1248px] px-5 py-3 relative mx-auto">
            {/* Logo */}
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/6f92263fde794fd91fb10442848bed84da061cb6?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
              alt="Company logo"
              className="w-[101px] object-contain"
            />

            {/* Mobile Menu Button */}
            <button id="menu-btn" className="block md:hidden text-indigo-950 focus:outline-none absolute right-0" >
              <svg
                className="w-8 h-8"
                fill="none"
                stroke="currentColor"
                viewBox="0 0 24 24"
                xmlns="http://www.w3.org/2000/svg"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  strokeWidth="2"
                  d="M4 6h16M4 12h16m-7 6h7"
                ></path>
              </svg>
            </button>

            {/* Navigation Wrapper */}
            <div id="menu" className="hidden md:flex relative items-center">
              {/* Background behind menu */}
              <div className="absolute inset-0 w-full h-full bg-indigo-950 rounded-full"></div>

              {/* Menu Items */}
              <ul className="flex gap-10 px-8 py-3 text-white text-base font-medium relative z-10">
                <a href="/">
                  <li className="cursor-pointer">Home</li>
                </a>
                <a href="/services">
                  <li className="cursor-pointer">Services</li>
                </a>
                <a href="/projects">
                  <li className="cursor-pointer">Projects</li>
                </a>
                <a href="/about">
                  <li className="cursor-pointer">About</li>
                </a>
              </ul>
            </div>

            {/* Contact Button */}
            <a href="/contact">
              <button className="px-5 py-2 bg-white text-indigo-950 font-bold rounded-full hidden md:block">
                Contact Us
              </button>
            </a>

            {/* Mobile Dropdown */}
            <div id="mobile-menu" className="absolute top-full left-0 w-full bg-white shadow-md hidden md:hidden">
              <ul className="flex flex-col items-center gap-4 py-4 text-indigo-950 font-medium">
                <a href="/">
                  <li className="cursor-pointer">Home</li>
                </a>
                <a href="/services">
                  <li className="cursor-pointer">Services</li>
                </a>
                <a href="/projects">
                  <li className="cursor-pointer">Projects</li>
                </a>
                <a href="/about">
                  <li className="cursor-pointer">About</li>
                </a>

                <li>
                  <a href="/contact">
                    <button className="px-5 py-2 bg-indigo-950 text-white font-bold rounded-full">
                      Contact Us
                    </button>
                  </a>
                </li>
              </ul>
            </div>
          </nav>

          <h1 className="relative mt-20 text-6xl font-semibold text-center text-white max-md:mt-10 max-md:max-w-full max-md:text-[2rem]">
            Eco-Friendly Electric Solutions
            <br />
            for a Sustainable Future
          </h1>

          <p className="relative mt-4 text-base text-center text-white max-w-[90%] sm:max-w-[417px] mx-auto">
            Discover cost-effective, eco-friendly solar panels and electrical solutions tailored to your needs.
          </p>

          <button className="flex relative gap-2.5 justify-center items-center px-3 py-2.5 max-md:mt-0 mt-8 text-base font-medium text-center text-black bg-white rounded-[100px]">
            <a href="/contact">
              {" "}
              <span className="self-stretch my-auto">Get Started</span>
            </a>
            <img
              src="https://cdn.builder.io/api/v1/image/assets/TEMP/875b5175a6d329c1e9401365dc845707ffbe81a1?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
              alt="Arrow icon"
              className="object-contain shrink-0 self-stretch my-auto w-5 aspect-square"
            />
          </button>

          <div className="flex items-stretch relative flex-wrap gap-10 self-start mt-28 w-full max-w-[1201px] max-md:mt-10 max-md:max-w-full max-md:flex-nowrap max-md:gap-4">
            <article className="h-full flex-1 min-w-[300px] max-w-[470px] py-4 px-4 rounded-3xl border border-white border-solid bg-white bg-opacity-50 max-md:min-w-0 max-md:flex-1 max-md:py-2 max-md:px-3">
              <div className="flex gap-5 max-md:flex-col max-md:gap-2 h-full">
                <div className="flex-shrink-0 max-md:w-full max-md:flex max-md:justify-center">
                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/8941e0c03ad34f41f73f06d534e1ee688b38cbd9?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                    alt="Success stories"
                    className="rounded-3xl w-[152px] h-auto object-cover max-md:w-[80px] max-md:h-[80px]"
                  />
                </div>
                <div className="flex-grow max-md:text-center">
                  <div className="self-stretch my-auto">
                    <h3 className="text-xl font-semibold text-black max-md:text-sm">
                      View our Success Stories
                    </h3>
                    <p className="mt-2.5 text-base text-black max-md:mt-1 max-md:text-xs">
                      Discover cost-effective, eco-friendly solar solutions
                    </p>
                  </div>
                </div>
              </div>
            </article>

            <div className="ml-auto flex flex-col items-center justify-center px-6 py-4 text-5xl text-center text-black whitespace-nowrap rounded-3xl border border-white border-solid bg-white bg-opacity-50 max-md:px-3 max-md:py-2 max-md:text-xl max-md:ml-0 max-md:w-auto max-md:flex-1 max-md:h-auto">
              <img
                src="https://cdn.builder.io/api/v1/image/assets/TEMP/936f5f8d152a96f542167b478eee62594e2b1f68?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                alt="Projects completed"
                className="object-contain rounded-full aspect-[1.64] w-[77px] max-md:w-[50px]"
              />
              <p className="mt-1.5 mb-0 text-4xl font-semibold max-md:text-6xl max-md:mt-1">50+</p>
              <p className="mt-0 text-base text-black  max-md:text-2xl max-md:leading-[1rem] max-md:mt-1 mb-0">
                Customers
              </p>
            </div>
          </div>
        </header>

        <section className="flex flex-col items-center justify-center px-16 py-4 w-full bg-white max-md:px-5 max-md:max-w-full">
          <div className="w-full max-w-7xl">
            <div className="partner-slider slider flex justify-center items-center">
              <div>
                <img src="assets/img/clients/1.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/2.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/3.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/4.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/5.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/6.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/7.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/8.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/9.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/10.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/11.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/12.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/13.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/14.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/15.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/16.png" className="object-contain aspect-square w-[120px]" />
              </div>
              <div>
                <img src="assets/img/clients/17.png" className="object-contain aspect-square w-[120px]" />
              </div>
            </div>
          </div>
        </section>

        <section className="self-center mt-20 w-full max-w-[1276px] max-md:mt-10 max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col">
            <div className="w-[42%] max-md:ml-0 max-md:w-full">
              <div className="w-full max-md:mt-10 max-md:max-w-full">
                <div className="max-md:p-2 flex gap-5 max-md:flex-row max-md:gap-4">
                  <div className="w-6/12 max-md:w-[48%]">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/39bf5873716953cf96c23bf3d2b79d8c0ee21da5?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                      alt="Company image"
                      className="object-contain w-full rounded-3xl aspect-square max-md:mt-0"
                    />
                  </div>
                  <div className="w-6/12 max-md:w-[48%]">
                    <div className="flex flex-col justify-center items-center px-11 w-full text-white rounded-3xl aspect-square bg-indigo-950 max-md:px-5 max-md:mt-0">
                      <div>
                        <p className="text-7xl font-semibold text-center max-md:text-4xl text-white">08</p>
                        <p className="text-sm text-white">Years of Experience</p>
                      </div>
                    </div>
                  </div>
                </div>

                <div className=" max-md:p-2 flex gap-5 mt-5 max-md:flex-row max-md:gap-4">
                  <div className="w-6/12 max-md:w-[48%]">
                    <div className="flex flex-col justify-center items-center px-11 w-full text-center bg-blue-100 rounded-3xl aspect-square text-indigo-950 max-md:px-5 max-md:mt-0">
                      <div>
                        <p className="text-7xl font-semibold max-md:text-4xl">10</p>
                        <p className="text-sm">Awards Wins</p>
                      </div>
                    </div>
                  </div>
                  <div className="w-6/12 max-md:w-[48%]">
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/7a7da95d400655bca8f3d42cfa11d7b8183c2e60?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                      alt="Company image"
                      className="object-contain w-full rounded-3xl aspect-square max-md:mt-0"
                    />
                  </div>
                </div>
              </div>
            </div>

            <div className="ml-5 w-[48%] max-md:ml-0 max-md:w-full">
              <div className="flex flex-col justify-center max-md:items-center max-md:text-center h-full px-2">
                <h2 className="text-4xl font-bold text-black mb-6 max-md:text-3xl">
                  Customized Electrical & Solar Solutions for Every Need!
                </h2>
                <p className="text-base text-gray-800 leading-relaxed">
                  At <strong>Al-Abbas Electric & Solar Power</strong>, we combine technology with trust, delivering reliable solar and electric services for both homes and industries. With <strong>8+ years</strong> of proven experience under the leadership of <strong>Syed Rameez Ali Shah</strong>, we are committed to powering a sustainable, energy-efficient future for generations to come.
                </p>

                {/* Service Icons */}
                <div className="mt-12 w-full max-md:mt-10">
                  <div className="flex justify-between gap-5 max-md:flex-col max-md:gap-8">
                    {/* Card 1 */}
                    <div className="flex-1 flex flex-col items-center text-center text-sm text-black hover:scale-105 transition-all">
                      <img
                        src="assets/img/home-icons/Group 83.png"
                        alt="On-time service"
                        className="w-16 h-16 object-contain rounded-full mb-4"
                      />
                      <p>Prompt & Reliable <br /> Service Delivery</p>
                    </div>

                    {/* Card 2 */}
                    <div className="flex-1 flex flex-col items-center text-center text-sm text-black hover:scale-105 transition-all">
                      <img
                        src="assets/img/home-icons/Group 84.png"
                        alt="24/7 service"
                        className="w-16 h-16 object-contain rounded-full mb-4"
                      />
                      <p>24/7 Emergency <br /> Support</p>
                    </div>

                    {/* Card 3 */}
                    <div className="flex-1 flex flex-col items-center text-center text-sm text-black hover:scale-105 transition-all">
                      <img
                        src="assets/img/home-icons/Group 85.png"
                        alt="Certified professionals"
                        className="w-16 h-16 object-contain rounded-full mb-4"
                      />
                      <p>Licensed & Trained <br /> Professionals</p>
                      <div className="flex justify-center mt-3">
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <section className="pt-20 pb-40 mt-36 w-full bg-blue-50 max-md:px-5 max-md:mt-10 max-md:max-w-full">
          <div className="flex gap-5 max-md:flex-col max-md:gap-8">
            <div className="w-2/4 max-md:w-full flex flex-col max-h">
              <div className="flex flex-col h-full p-6 rounded-3xl">
                <h2 className="text-4xl font-semibold text-black">Why Choose Us?</h2>
                <div className="flex flex-col gap-8 mt-8">
                  <div className="flex items-start gap-5">
                    <img
                      src="assets/img/home-icons/Group 105.png"
                      alt="Affordable prices icon"
                      className="w-16 h-16 rounded-full"
                    />
                    <div>
                      <h3 className="text-xl font-medium">Affordable Prices</h3>
                      <p className="text-base">Top-quality solutions within your budget.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-5">
                    <img
                      src="assets/img/home-icons/Group 106.png"
                      alt="Quality assistance icon"
                      className="w-16 h-16 rounded-full"
                    />
                    <div>
                      <h3 className="text-xl font-medium">Quality Assistance</h3>
                      <p className="text-base">Expert support you can rely on.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-5">
                    <img
                      src="assets/img/home-icons/Group 107.png"
                      alt="Free estimation icon"
                      className="w-16 h-16 rounded-full"
                    />
                    <div>
                      <h3 className="text-xl font-medium">Free Estimation</h3>
                      <p className="text-base">Get a no-cost quote today.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-5">
                    <img
                      src="assets/img/home-icons/Group 108.png"
                      alt="Advanced systems icon"
                      className="w-16 h-16 rounded-full"
                    />
                    <div>
                      <h3 className="text-xl font-medium">Advanced Systems</h3>
                      <p className="text-base">Cutting-edge technology for efficiency.</p>
                    </div>
                  </div>
                  <div className="flex items-start gap-5">
                    <img
                      src="assets/img/home-icons/Group 109.png"
                      alt="Optimized solutions icon"
                      className="w-16 h-16 rounded-full"
                    />
                    <div>
                      <h3 className="text-xl font-medium">Optimized Solutions</h3>
                      <p className="text-base">Smart energy solutions for maximum efficiency.</p>
                    </div>
                  </div>
                </div>

                <div className="relative">
                  <button className="mt-8 px-6 py-3 bg-indigo-950 text-white rounded-full flex items-center gap-2 self-start">
                    <span>Get Started</span>
                    <img
                      src="https://cdn.builder.io/api/v1/image/assets/TEMP/5a33d1f1ce8a9ea4f9f05da1cbd430a1f75c9fb0?apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                      alt="Arrow icon"
                      className="w-5 h-5"
                    />
                  </button>
                </div>
              </div>
            </div>

            <div className="w-3/5 max-md:w-full flex flex-col md:max-h-[600px]">
              <div className="h-full flex flex-col gap-5">
                <img
                  src="https://cdn.builder.io/api/v1/image/assets/TEMP/90c37aa2299ec520e6f7f5755d6d7b4aef17d587?apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                  alt="Solar panels installation"
                  className="w-full rounded-3xl object-cover h-[50%]"
                />

                <div className="flex gap-5 h-[50%] max-md:flex-col">
                  <article className="flex-1 bg-indigo-950 rounded-3xl p-5 text-white flex flex-col">
                    <div className="flex justify-between">
                      <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/14d9446fe93a049aff1ef7dede61d9cfa65610c6?apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                        alt="Electric car charging"
                        className="w-32 h-12 object-contain"
                      />
                      <img
                        src="https://cdn.builder.io/api/v1/image/assets/TEMP/4cf76bc0ca49ebd27f73151d06f55bf40a878db6?apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                        alt="Green energy icon"
                        className="w-12 h-12 rounded-full"
                      />
                    </div>
                    <h3 className="mt-4 text-xl font-semibold">A Greener Way to Get Around</h3>
                    <p className="mt-3 text-slate-50 flex-grow">
                      We're on a mission to transform the way the world harnesses energy.
                    </p>
                  </article>

                  <img
                    src="https://cdn.builder.io/api/v1/image/assets/TEMP/1387be84bd578e6e381ec3ff314e4dd58c4a64d4?apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                    alt="Solar installation"
                    className="flex-1 rounded-3xl object-cover"
                  />
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="flex flex-col px-16 mt-44 w-full max-md:px-5 max-md:mt-10 max-md:max-w-full">
          <div className="w-full max-w-[1211px] max-md:max-w-full">
            <div className="flex gap-5 max-md:flex-col">
              <div className="w-[30%] max-md:ml-0 max-md:w-full">
                <div className="text-black max-md:mt-10">
                  <h2 className="mr-6 text-4xl font-semibold max-md:mr-2.5">
                    Switching Your Business to Solar Made Simple
                  </h2>
                  <p className="mt-5 text-base">
                    Seamless solar integration for efficient and sustainable industrial power!
                  </p>
                </div>
              </div>
              <div className="ml-5 w-[70%] max-md:ml-0 max-md:w-full">
                <div className="grow max-md:mt-10 max-md:max-w-full">
                  <div className="flex gap-5 max-md:flex-col">
                    <div className="w-[56%] max-md:ml-0 max-md:w-full">
                      <div className="flex relative flex-col grow items-start px-6 pt-96 pb-6 rounded-3xl aspect-[0.617] max-md:px-5 max-md:pt-24 max-md:mt-10">
                        <img
                          src="https://cdn.builder.io/api/v1/image/assets/TEMP/6a6f1d7e0be86fe9e6daeb657b6304848f0aa00b?placeholderIfAbsent=true&apiKey=a6aeafbfb8ee495fa82398b0de2ab431"
                          alt="Solar panels"
                          className="object-cover absolute inset-0 size-full"
                        />
                        <div className="flex relative flex-col items-start pt-3.5 pr-9 pb-6 pl-3.5 max-w-full bg-white rounded-xl w-[174px] max-md:pr-5">
                          <button className="gap-2.5 self-stretch px-2.5 py-2 text-sm font-medium text-center text-white bg-indigo-950 rounded-[100px]">
                            Get Free Qoute
                          </button>
                          <h3 className="mt-6 text-xl font-semibold text-black">Powerful Solar Plates</h3>
                        </div>
                      </div>
                    </div>
                    <div className="ml-5 w-[44%] max-md:ml-0 max-md:w-full">
                      <div className="flex flex-col items-start self-stretch my-auto text-xl font-medium text-black max-md:mt-10 max-md:text-center">
                        <div className="flex justify-center max-md:items-center shrink-0 rounded-full h-[68px] w-[68px] max-md:mx-auto">
                          <img
                            src="assets/img/home-icons/Group 88.png"
                            alt="Consultation Icon"
                            className="h-4/5 w-4/5 object-contain"
                          />
                        </div>
                        <h3 className="mt-5 max-md:mt-3 max-md:mx-auto">Consultation</h3>
                        <p className="self-stretch mt-2 text-base max-md:mt-2 max-md:mx-auto">
                          Free assessment of your energy needs.
                        </p>

                        <div className="flex justify-center items-center shrink-0 mt-16 rounded-full h-[68px] w-[68px] max-md:mx-auto">
                          <img
                            src="assets/img/home-icons/Group 87.png"
                            alt="Installation Icon"
                            className="h-4/5 w-4/5 object-contain"
                          />
                        </div>
                        <h3 className="mt-5 max-md:mt-3 max-md:mx-auto">Installation</h3>
                        <p className="mt-2 text-base max-md:mt-2 max-md:mx-auto">Professional and hassle-free setup.</p>

                        <div className="flex justify-center items-center shrink-0 mt-16  rounded-full h-[68px] w-[68px] max-md:mx-auto">
                          <img
                            src="assets/img/home-icons/Group 86.png"
                            alt="Savings Icon"
                            className="h-4/5 w-4/5 object-contain"
                          />
                        </div>

                        <h3 className="mt-5 max-md:mt-3 max-md max-md:mx-auto">Savings</h3>
                        <p className="mt-2 text-base max-md:mt-2 max-md:mx-auto">
                          Start saving on energy from day one.
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div className="self-end mt-44 mr-0 w-full max-w-[1184px] max-md:mt-10 max-md:mr-2.5 max-md:max-w-full">
            <div className="flex flex-col mb-10 max-md:p-10">
              <div className="flex gap-5 max-md:flex-col max-md:items-center">
                <div className="w-[29%] max-md:w-full">
                  <div className="max-md:mt-10">
                    <h2 className="mr-6 text-3xl font-semibold text-black max-md:mr-2.5 flex items-center gap-2">
                      Domestic Service
                      <button
                        className="toggle-button bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center w-8 h-12 max-md:block hidden rounded-xl"
                        onClick={() => toggleAccordion("domestic")}
                      >
                        <i
                          className={`fa-solid fa-arrow-${domesticOpen ? "up" : "down"} text-white text-sm transform transition-transform -mt-0.5`}
                          id="arrow-domestic-mobile"
                        ></i>
                      </button>
                    </h2>
                  </div>
                </div>

                <div className="w-[60%] max-md:w-full flex flex-col">
                  <div className="flex justify-between items-center max-md:flex-col max-md:items-end">
                    <p className="text-base text-black max-md:max-w-full">
                      Al Abbas delivers expert industrial electrical services, ensuring safety, efficiency, and
                      reliability with advanced tools and skilled technicians.
                    </p>
                    <button
                      className="toggle-button p-[0.4rem] bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center w-8 h-8 md:block hidden rounded-xl"
                      onClick={() => toggleAccordion("domestic")}
                    >
                      <i
                        className={`fa-solid fa-arrow-${domesticOpen ? "up" : "down"}  text-white`}
                        id="arrow-domestic-desktop"
                      ></i>
                    </button>
                  </div>
                  <div className="max-md:mt-10"></div>
                </div>
              </div>

              <div
                id="domestic-accordion"
                className={`accordion-content ${domesticOpen ? "" : "hidden"}`}
              >
                <div className="mt-10 flex gap-5 max-md:flex-col">
                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-orange-100 rounded-[100px] text-indigo-950">
                        Indoor Lighting
                      </span>
                      <p className="mt-4 text-black">
                        We provide a diverse range of indoor lighting solutions tailored to your needs.
                      </p>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-teal-100 rounded-[100px] text-indigo-950">
                        Security System
                      </span>
                      <p className="mt-4 text-black">
                        Our experts design and install tailored security systems for your needs.
                      </p>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-blue-100 rounded-[100px] text-indigo-950">
                        Panel Fixing Service
                      </span>
                      <p className="mt-4 text-black">
                        Our skilled technicians use advanced tools to diagnose and repair panel issues efficiently.
                      </p>
                    </div>
                  </div>
                </div>

                <img
                  src="assets/img/home-icons/Rectangle 10.png"
                  alt="Domestic electrical services"
                  className="object-contain mt-10 w-full rounded-3xl aspect-[2.18] max-md:max-w-full"
                />
              </div>
            </div>

            <div className="flex flex-col mb-10 max-md:p-10 max-md:-mt-[6rem]">
              <div className="flex gap-5 max-md:flex-col max-md:items-center">
                <div className="w-[29%] max-md:w-full">
                  <div className="max-md:mt-10">
                    <h2 className="mr-6 text-3xl font-semibold text-black max-md:mr-2.5 flex items-center gap-2">
                      Industrial Service
                      <button
                        className="toggle-button bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center w-8 h-12 max-md:block hidden rounded-xl"
                        onClick={() => toggleAccordion("industrial")}
                      >
                        <i
                          className={`fa-solid fa-arrow-${industrialOpen ? "up" : "down"}  text-white text-sm`}
                          id="arrow-industrial-mobile"
                        ></i>
                      </button>
                    </h2>
                  </div>
                </div>

                <div className="w-[60%] max-md:w-full flex flex-col">
                  <div className="flex justify-between items-center max-md:flex-col max-md:items-end">
                    <p className="text-base text-black max-md:max-w-full">
                      Our team of experts provides industrial electrical services tailored for factories, large
                      businesses, and warehouses, ensuring efficiency and compliance.
                    </p>
                    <button
                      className="toggle-button p-[0.4rem] bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center w-8 h-8 md:block hidden rounded-xl"
                      onClick={() => toggleAccordion("industrial")}
                    >
                      <i
                        className={`fa-solid fa-arrow-${industrialOpen ? "up" : "down"}  text-white`}
                        id="arrow-industrial-desktop"
                      ></i>
                    </button>
                  </div>
                  <div className="max-md:mt-10"></div>
                </div>
              </div>

              <div
                id="industrial-accordion"
                className={`accordion-content ${industrialOpen ? "" : "hidden"}`}
              >
                <div className="mt-10 flex gap-5 max-md:flex-col">
                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-orange-100 rounded-[100px] text-indigo-950">
                        Underground Cabling
                      </span>
                      <p className="mt-4 text-black">
                        Our team of experts can design and install underground cable systems that are safe, reliable,
                        and efficient.
                      </p>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-teal-100 rounded-[100px] text-indigo-950">
                        Overhead cabling
                      </span>
                      <p className="mt-4 text-black">
                        At our electric company, we offer top-quality overhead cabling services for both residential and
                        commercial properties.
                      </p>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-blue-100 rounded-[100px] text-indigo-950">
                        Indoor Lighting
                      </span>
                      <p className="mt-4 text-black">
                        We offer a wide range of indoor lighting solutions to meet all of your needs.
                      </p>
                    </div>
                  </div>
                </div>
                <div className="mt-10 flex gap-5 max-md:flex-col">
                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-orange-100 rounded-[100px] text-indigo-950">
                        Power Outlets
                      </span>
                      <p className="mt-4 text-black">
                        Our skilled technicians use the techniques to ensure that your power outlets are safe, reliable,
                        and efficient.
                      </p>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-teal-100 rounded-[100px] text-indigo-950">
                        Electrical Panels
                      </span>
                      <p className="mt-4 text-black">
                        Our team of experts can repair, replace, or upgrade your electrical panels
                      </p>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-blue-100 rounded-[100px] text-indigo-950">
                        Security System
                      </span>
                      <p className="mt-4 text-black">
                        we offer advanced security systems for both residential and commercial properties.
                      </p>
                    </div>
                  </div>
                </div>
                <img
                  src="assets/img/home-icons/Rectangle 35.png"
                  alt="Domestic electrical services"
                  className="object-contain mt-10 w-full rounded-3xl aspect-[2.18] max-md:max-w-full"
                />
              </div>
            </div>

            <div className="flex flex-col mb-20 max-md:p-10  max-md:-mt-[6rem]">
              <div className="flex gap-5 max-md:flex-col max-md:items-center">
                <div className="w-[29%] max-md:w-full">
                  <div className="max-md:mt-10">
                    <h2 className="mr-6 text-3xl font-semibold text-black max-md:mr-2.5 flex items-center gap-2">
                      Commercial Service
                      <button
                        className="toggle-button bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center w-8 h-12 max-md:block hidden rounded-xl"
                        onClick={() => toggleAccordion("commercial")}
                      >
                        <i
                          className={`fa-solid fa-arrow-${commercialOpen ? "up" : "down"}  text-white text-sm`}
                          id="arrow-commercial-mobile"
                        ></i>
                      </button>
                    </h2>
                  </div>
                </div>

                <div className="w-[60%] max-md:w-full flex flex-col">
                  <div className="flex justify-between items-center max-md:flex-col max-md:items-end">
                    <p className="text-base text-black max-md:max-w-full">
                      We offer comprehensive commercial electrical services, from installation to maintenance, for
                      businesses, office buildings, and retail spaces.
                    </p>
                    <button
                      className="toggle-button p-[0.4rem] bg-blue-900 hover:bg-blue-800 transition-all flex items-center justify-center w-8 h-8 md:block hidden rounded-xl"
                      onClick={() => toggleAccordion("commercial")}
                    >
                      <i
                        className={`fa-solid fa-arrow-${commercialOpen ? "up" : "down"}  text-white`}
                        id="arrow-commercial-desktop"
                      ></i>
                    </button>
                  </div>
                  <div className="max-md:mt-10"></div>
                </div>
              </div>

              <div
                id="commercial-accordion"
                className={`accordion-content ${commercialOpen ? "" : "hidden"}`}
              >
                <div className="mt-10 flex gap-5 max-md:flex-col">
                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-orange-100 rounded-[100px] text-indigo-950">
                        Electric connect
                      </span>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-teal-100 rounded-[100px] text-indigo-950">
                        Power outlets
                      </span>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-blue-100 rounded-[100px] text-indigo-950">
                        Appliances overheat
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-5 flex gap-5 max-md:flex-col">
                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-orange-100 rounded-[100px] text-indigo-950">
                        Electrical panel setup
                      </span>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-teal-100 rounded-[100px] text-indigo-950">
                        Outlet installation and repair
                      </span>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-blue-100 rounded-[100px] text-indigo-950">
                        Ceiling fan installation and repair
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-5 flex gap-5 max-md:flex-col">
                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-orange-100 rounded-[100px] text-indigo-950">
                        All lighting work
                      </span>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-teal-100 rounded-[100px] text-indigo-950">
                        Electrical set up and rewiring
                      </span>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-blue-100 rounded-[100px] text-indigo-950">
                        Solar System
                      </span>
                    </div>
                  </div>
                </div>

                <div className="mt-5 flex gap-5 max-md:flex-col">
                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-orange-100 rounded-[100px] text-indigo-950">
                        Street lights
                      </span>
                    </div>
                  </div>

                  <div className="w-4/12 max-md:w-full">
                    <div className="flex flex-col w-full text-base">
                      <span className="gap-2.5 self-start p-2.5 bg-teal-100 rounded-[100px] text-indigo-950">
                        Lights distribution
                      </span>
                    </div>
                  </div>
                </div>

                <img
                  src="assets/img/home-icons/Rectangle 34.png"
                  alt="Domestic electrical services"
                  className="object-contain mt-10 w-full rounded-3xl aspect-[2.18] max-md:max-w-full"
                />
              </div>
            </div>
          </div>

          <div className="slider-container">
            <div className="slider">
              <div>
                <img src="assets/img/1.png" alt="Image 1" />
              </div>
              <div>
                <img src="assets/img/2.png" alt="Image 2" />
              </div>
              <div>
                <img src="assets/img/3.png" alt="Image 3" />
              </div>
              <div>
                <img src="assets/img/4.png" alt="Image 4" />
              </div>
              <div>
                <img src="assets/img/5.png" alt="Image 5" />
              </div>
              <div>
                <img src="assets/img/6.png" alt="Image 6" />
              </div>
              <div>
                <img src="assets/img/7.png" alt="Image 7" />
              </div>
            </div>
          </div>

          <Quote />
          {/* Footer */}
          <Footer />
        </div>
      </div>
    </div>
  );
}

export default Home;